export default [
  {
    path: '/admin/corporate/branch-profiles',
    name: 'branchIndex',
    meta: { requiresAuth: true },
    component: () => import('@/pages/corporate/branch/index.vue')
  },
]
